import React, { useEffect, useState } from 'react';
import "./eventDetails.css";
import { useParams } from 'react-router';
import { get } from 'react-scroll/modules/mixins/scroller';
import axios from 'axios';
import Masonry from 'react-layout-masonry';


function C2wEventsDetails() {
    const { slug } = useParams();
    const [event, setEvent] = useState();
    const fetchData = async () => {
        try {
            const data = await axios.get("/data/events.json")
            const event = data.data?.events?.find(
                (c) => c.slug === slug
            );
            setEvent(event)
            console.log(event)
        } catch (err) {
            console.log(err)
        }
    }
    useEffect(() => {
        fetchData()
    }, [slug]);
    // Function to generate random size and position styles
    const generateRandomStyle = () => {
        const sizes = ["span 1", "span 2", "span 3"]; // Grid span options
        const randomSize = sizes[Math.floor(Math.random() * sizes.length)];

        return {
            gridColumn: randomSize,
            gridRow: randomSize,
            transform: `rotate(${Math.random() * 10 - 5}deg)`, // Slight rotation
        };
    };
    return (
        <div className='C2wEventsDetails'>
            <div className='C2wEventsDetails_container'>
                <div className="gallery-container">
                    <h1 className="gallery-title">{event?.name}</h1>
                    <hr className='C2wEvent_horizontalline'></hr>
                    <div className="grid-container">
                        {event && event.imagesData.map((image) => (
                            <div key={image.id} className="grid-image">
                                <img src={image.src} alt={image.id} />
                            </div>
                        ))}
                        {/* <Masonry
      columns={{ 640: 1, 768: 2, 1024: 3, 1280: 5 }}
      gap={16}
    >
      {event && event.imagesData.map((image) => {
        return <Item {...item} />;
      })}
    </Masonry> */}
                    </div>
                </div>


            </div>
        </div>
    )
}

export default C2wEventsDetails
